<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="valueString" hidden="hidden">
            <el-date-picker
                    class="qweelement"
                    v-model="data[name]"
                    :type="type"
                    placeholder="选择日期"
                    :disabled="disabled">
            </el-date-picker>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
    </el-col>
</template>

<style>
    /* .qweelement1{
        display :none;
    } */
</style>

<script>
    import baseDateField from "./BaseDateField"
    export default {
        name:"DateField",
        mixins:[baseDateField]
    }
</script>